<mat-card class="example-card">
    <p>
        You are welcome!
    </p>
</mat-card>